<!-- Tells user how far along they are. -->
<template>
</template>

<script>
export default {
	name: "CheckoutProgress"
}
</script>
